// organize-imports-ignore
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

import vuetify from './vuetify';
import { notivue } from './notivue';
import i18n from './i18n';
import validation from './validation';
import yup from './yup';
import { VueQueryPlugin } from '@tanstack/vue-query';
import VueApexCharts from 'vue3-apexcharts';
import { vueQueryConfig } from './vue-query';

export function registerPlugins(app) {
  app
    .use(vuetify)
    .use(pinia)
    .use(notivue)
    .use(i18n)
    .use(validation)
    .use(yup)
    .use(VueQueryPlugin, vueQueryConfig)
    .use(VueApexCharts);
}
